
const errPlugin = (Vue, NODE_ENV) => {
  Vue = Vue || window.Vue;
  if (!Vue || !Vue.config) return;
  Vue.config.errorHandler = function (err, vm, info) {
    // 判断是否生产环境
    if (NODE_ENV === "development") {
      // 输出错误日志
      var defaults = {
        //  设备浏览器的信息集合
        ua: window.navigator.userAgent,
        errUrl: window.location.href,
        errMsg: err.stack
      }
      post(defaults)
    }
    console.log(err)
    console.error(err)
  }
}


function post (obj) {
  var httpRequest = new XMLHttpRequest()
  httpRequest.open('POST', 'http://127.0.0.1:3000/log', true)
  httpRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded")

  let str = ''
  for (let key in obj) {
    const item = key + '=' + obj[key]
    if (str.length == 0) {
      str = item
    } else {
      str += "&" + item
    }
  }
  console.log(str)
  httpRequest.send(str)
  /**
   * 获取数据后的处理程序
   */
  httpRequest.onreadystatechange = function () {
  };
}

export default errPlugin
